var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg029Padlock = function Svg029Padlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346 45c0-24.814-20.186-45-45-45h-90c-24.814 0-45 20.186-45 45v135h-60v332h300V180h-60zm-150 0c0-8.276 6.724-15 15-15h90c8.276 0 15 6.724 15 15v135H196zm15 376h-30v-30h30zm0-60h-30v-30h30zm0-60h-30v-30h30zm60 120h-30v-30h30zm0-60h-30v-30h30zm0-60h-30v-30h30zm60 120h-30v-30h30zm0-60h-30v-30h30zm0-60h-30v-30h30z"
  })));
};
export default Svg029Padlock;